import { cn } from "../../lib/utils.ts";
import { IconMark } from "../brand/icons.tsx";

export interface LoadingStateProps {
  label?: string;
  className?: string;
}

/** Branded loader — the coupe mark inside a spinning gold ring with a warm glow. */
export function LoadingState({ label = "กำลังเปิดห้องให้คุณ…", className }: LoadingStateProps) {
  return (
    <div
      className={cn("flex flex-col items-center justify-center gap-5 py-12 text-center", className)}
      role="status"
      aria-live="polite"
    >
      <div className="relative text-gold">
        <div
          className="absolute"
          style={{
            inset: -20,
            background: "radial-gradient(circle, var(--amber-glow), transparent 68%)",
            filter: "blur(8px)",
          }}
          aria-hidden="true"
        />
        <div
          className="relative grid size-[4.875rem] place-items-center rounded-full"
          style={{
            background:
              "radial-gradient(circle at 50% 32%, oklch(24% 0.02 60), oklch(16% 0.012 58))",
            border: "1px solid oklch(79% 0.12 80 / 40%)",
          }}
        >
          <div
            className="jod-spin absolute rounded-full border-[1.5px] border-transparent"
            style={{ inset: 5, borderTopColor: "var(--gold-500)" }}
            aria-hidden="true"
          />
          <IconMark size={38} />
        </div>
      </div>
      <p className="h-display text-cream-2 text-[1.05rem]">{label}</p>
    </div>
  );
}
